/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExpireDangerIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <circle fill='#f24e4e' cx="21" cy="21" r="19.5"/>
      <path fill='#fff' d="M21,3A18,18,0,1,1,3,21,18,18,0,0,1,21,3m0-3A21,21,0,1,0,42,21,21,21,0,0,0,21,0Z"/>
      <path fill='#fff'
            d="M24.6,21.26l5.4,5.4a2.55,2.55,0,0,1-3.6,3.6L21,24.86l-5.4,5.4a2.55,2.55,0,0,1-3.6-3.6l5.4-5.4L11.74,15.6a2.55,2.55,0,0,1,3.6-3.6L21,17.4,26.4,12A2.55,2.55,0,0,1,30,15.6Z"/>
    </g>
  ]
  getViewBox = () => '0 0 42 42'
}
